import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';
import { AuthenticationTypeSummary } from '../../types';

const END_POINT = '/metric/authenticationType';

export type AuthenticationTypeSummaryDto = AuthenticationTypeSummary;

const convertToAuthenticationTypeSummary = (data: AuthenticationTypeSummaryDto): AuthenticationTypeSummary => {
    return data;
};

const fetchAuthenticationTypeSummary = async (filters: QueryFilters) => {
    const data = await apiGet<AuthenticationTypeSummaryDto>(
        `${API_BASE_URL}${END_POINT}`,
        buildUniversalMfaQueryParams(filters)
    );

    return data;
};

export const useAuthenticationTypeSummary = (filters: QueryFilters): UseQueryResult<AuthenticationTypeSummary> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.authenticationTypeSummary(filters),
        queryFn: () => fetchAuthenticationTypeSummary(filters),
        select: convertToAuthenticationTypeSummary
    });
};
